'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  padding-top: 56.25%;\n\n  .player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n  .react-player__preview {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n  }\n'], ['\n  position: relative;\n  padding-top: 56.25%;\n\n  .player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n  .react-player__preview {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = (0, _bduiStyles.css)(_templateObject);

function VideoPlayer(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(_reactPlayer2.default, Object.assign({
      className: 'player'
    }, props, {
      width: '100%',
      height: '100%'
    }))
  );
}

VideoPlayer.propTypes = _extends({
  className: _propTypes2.default.string
}, _reactPlayer2.default.propTypes);

VideoPlayer.defaultProps = _extends({
  className: undefined
}, _reactPlayer2.default.defaultProps);

exports.default = (0, _bduiStyles2.default)(defaultStyles)(VideoPlayer);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-videoplayer/build/VideoPlayer.js
// module id = 1279
// module chunks = 0